"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconInputGroupAddon = require("../group-addons/IconInputGroupAddon");
var _Svg = require("../../../Svg");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var shortArrow = function shortArrow(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.99996 0.343L0.756958 4.586L2.17196 6L4.99996 3.171L7.82796 6L9.24296 4.586L4.99996 0.343Z",
    fill: "currentColor"
  }));
};
shortArrow.defaultProps = {
  width: "10",
  height: "6",
  viewBox: "0 0 10 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var DropdownIndicator = (0, _styledComponents.default)(_IconInputGroupAddon.IconInputGroupAddon).attrs(function () {
  return {
    children: /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
      color: "tertiaryShade",
      as: shortArrow,
      width: 12,
      height: 8
    }),
    addonType: 'append',
    clickable: true
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  height: 100%;\n  right: 16px;\n  z-index: 0;\n  padding: 0 !important;\n  transform: rotate(", ");\n"])), function (props) {
  return "".concat(props.selectProps.menuIsOpen ? 0 : 180, "deg");
});
exports.DropdownIndicator = DropdownIndicator;